import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { RootState } from "../../../redux/store";
import { getClaimTimelineKPIs } from "../api/ClaimAPI";
import { useQuery } from "@tanstack/react-query";
import { PaginationFilterDto } from "../../../types/Pagination";

type QueryFnTypeClaimTimelineKPIs = typeof getClaimTimelineKPIs;

export const useClaimTimelineKPIs = (config?: QueryConfig<QueryFnTypeClaimTimelineKPIs>) => {
    const filters = useSelector((state: RootState) => state.filters.claims.selectedFilters);
    const filterByUser = useSelector((state: RootState) => state.filters.claims.filterByCurrentUser ?? false);
    const currentUser = useSelector((state: RootState) => state.currentUserInfo.data);

    const paginationFilters: PaginationFilterDto = {
        filters,
        selectedOrganizationalStructureIds: currentUser.selectedOrganizationalStructureIds,
        filterByCurrentUser: filterByUser,
        pageNumber: 1,
        pageSize: 1
    };

    return useQuery<ExtractFnReturnType<QueryFnTypeClaimTimelineKPIs>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ["claimTimelineKPIs", filterByUser, filters, currentUser],
        queryFn: () => getClaimTimelineKPIs(paginationFilters), 
    });
}